module.exports = __webpack_public_path__ + "img/my-guessing-shadow.c52d7550.png";